<gl-box>
  <div class="wrapper">
    <form (ngSubmit)="onSubmit($event)" class="form" [formGroup]="form">
      <div class="loadFields readOnlyFields" data-ctx="pallet-group-edit-load-fields">
        <div class="input-row input-row-name">
          <gl-input-container>
            <input data-ctx="input-name" formControlName="name" normal-input placeholder="name" type="text" />
          </gl-input-container>
        </div>
        <div class="input-row">
          @if (currentType === 0 || currentType === undefined || currentType === 2) {
            <gl-input-container [units]="'length'">
              <input
                data-ctx="input-length"
                [numericType]="'float'"
                formControlName="length"
                normal-input
                placeholder="length"
                type="text"
                />
            </gl-input-container>
          }
          @if (currentType === 0 || currentType === undefined) {
            <gl-input-container [units]="'length'">
              <input
                [numericType]="'float'"
                formControlName="width"
                normal-input
                placeholder="width"
                type="text"
                />
            </gl-input-container>
          }
          @if (currentType === 0 || currentType === undefined || currentType === 1) {
            <gl-input-container [units]="'length'">
              <input
                [numericType]="'float'"
                formControlName="height"
                normal-input
                placeholder="height"
                type="text"
                />
            </gl-input-container>
          }
          @if (currentType === 1 || currentType === 2) {
            <gl-input-container [units]="'length'">
              <input
                type="text"
                [numericType]="'float'"
                placeholder="diameter"
                normal-input
                formControlName="diameter"
                />
            </gl-input-container>
          }
        </div>
        <div class="input-row">
          <gl-input-container [units]="'weight'">
            <input
              [numericType]="'float'"
              formControlName="weight"
              normal-input
              placeholder="weight"
              type="text"
              />
          </gl-input-container>
          <gl-input-container>
            <input
              [numericType]="'float'"
              formControlName="quantity"
              min="1"
              number-input
              placeholder="quantity"
              type="number"
              />
          </gl-input-container>
          <gl-input-container [units]="'weight'">
            <input
              [numericType]="'float'"
              formControlName="sumOfWeights"
              normal-input
              placeholder="sum_of_weights"
              type="text"
              />
          </gl-input-container>
        </div>
      </div>

      <div class="tabs" data-ctx="pallet-group-edit-tabs">
        <div
          (click)="openTab('layers')"
          [ngClass]="{ active: activeTab === 'layers' }"
          [glPremium]="true"
          class="tab"
          data-ctx="tab-layers"
          >
          <div class="tabText">{{ 'arrangement_tab' | translate }}</div>
        </div>
        <div
          (click)="openTab('interlayers')"
          [ngClass]="{ active: activeTab === 'interlayers' }"
          [glPremium]="true"
          class="tab"
          data-ctx="tab-interlayers"
          >
          <div class="tabText">{{ 'interlayers_tab' | translate }}</div>
        </div>
      </div>

      <div
        class="tabContent"
        [class.tabContentHidden]="activeTab !== 'layers'"
        data-ctx="pallet-group-edit-layers-tab"
        >
        <gl-load-pallet-arrangement
          #arrangementRef
          [editMode]="true"
          [editRows]="editRows"
          [layersLoading]="layersLoading"
          [loadLength]="palletGroup.dimensions?.length"
          [loadWidth]="palletGroup.dimensions?.width"
          [loadHeight]="palletGroup.dimensions?.height"
          [loadWeight]="palletGroup.weight"
        ></gl-load-pallet-arrangement>
      </div>

      @if (renderInterlayersForm) {
        <div
          class="tabContent"
          [class.tabContentHidden]="activeTab !== 'interlayers'"
          data-ctx="pallet-group-edit-interlayers-tab"
          >
          <gl-load-interlayers
            #interlayersForm
            [listEditMode]="true"
            [isPallet]="true"
            [disabled]="false"
            [layerQuantity]="maxFrequencyLayers + 1"
            [initialInterlayer]="palletGroup.interlayer"
            [savedInterlayerLoads]="[]"
          ></gl-load-interlayers>
        </div>
      }

      <div class="actions">
        <button
          data-ctx="button-submit-pallet-group-edit"
          submit-button
          type="submit"
          [class.saveButton]="highlightSaveButton"
          >
          {{ 'save' | translate }}
        </button>
      </div>
    </form>
  </div>
</gl-box>
